function Logosvg(props) {
  return (
    <svg
      id='Logo_Atelier_zucchetti'
      data-name='Logo_Atelier_zucchetti'
      xmlns='http://www.w3.org/2000/svg'
      width='200'
      viewBox='0 0 927.615 482.815'
    >
      <g id='Atelier-zucchetti-logo' transform='translate(0.824)'>
        <path
          id='Senza_titolo-1'
          data-name='Senza titolo-1'
          d='M84.767,211.129h-37.7l18.1-129.676ZM707.572,32.3c24.138-1.409,27.142,31.05,27.142,46.15,0,3,1.489,48.25-18.1,48.25H696.992V33.177l10.554-.9h0ZM722.645,0c42.215,16.588,45.246,46.761,45.246,78.422,0,25.653-3,67.868-43.73,79.911l54.284,144.775H745.268L694.014,174.921V303.109H663.842V0h58.83ZM633.669,0V31.661H576.355v96.526h55.8v34.692h-55.8V271.447h57.315v31.661H546.209V0ZM517.1,0V303.109H486.953V0ZM407.468,0V271.447h55.8v31.661H377.3V0h30.173ZM347.149,0V31.661h-58.8v96.526h55.8v34.692h-55.8V271.447h58.8v31.661H258.173V0ZM243.073,0V31.661H200.858V303.109H169.2V31.661H129.986V0H243.1ZM80.221,0,132.99,303.109H98.617c-3-19.619-6.566-37.324-10.554-61.807H43.11c-5,26.823-7.364,41.444-11.139,61.807H.31L50.075,0Z'
          transform='translate(-0.31)'
          fill='#162640'
          fillRule='evenodd'
        />
        <path
          id='Tracciato_575-2'
          data-name='Tracciato 575-2'
          d='M336.073,209.886,446.9,148.664,418.163,87.547l-45.512,21.214L351.491,63.17,289.87,91.987l46.2,117.9Z'
          transform='translate(479.891 104.76)'
          fill='#a2ca00'
        />
      </g>
      <g id='Raggruppa_236' data-name='Raggruppa 236' transform='translate(0 365.208)'>
        <g id='Raggruppa_235' data-name='Raggruppa 235' transform='translate(156.26 50.536)'>
          <path
            id='Tracciato_577'
            data-name='Tracciato 577'
            d='M58.807,220.787l27.248-52.8H61.146a27.2,27.2,0,0,1-.532-5.5,30.165,30.165,0,0,1,.532-5.689h43.491l.718,1.09L78.372,210.5H104a27.2,27.2,0,0,1,.532,5.5,30.163,30.163,0,0,1-.532,5.689H59.418l-.638-.9Z'
            transform='translate(-58.78 -155.71)'
            fill='#575756'
          />
          <path
            id='Tracciato_578'
            data-name='Tracciato 578'
            d='M80.11,157.082c1.143-.186,2.26-.292,3.35-.372q1.635-.08,3.35-.08c1.01,0,2.074.027,3.164.08a30.018,30.018,0,0,1,3.35.372v33.655c0,3.669.133,6.806.4,9.437a20.269,20.269,0,0,0,1.622,6.486,8.422,8.422,0,0,0,3.429,3.8,11.648,11.648,0,0,0,5.742,1.223,11.361,11.361,0,0,0,5.689-1.223,8.189,8.189,0,0,0,3.376-3.8,19.769,19.769,0,0,0,1.622-6.486c.266-2.605.4-5.769.4-9.437V157.082c1.2-.186,2.339-.292,3.429-.372,1.09-.053,2.127-.08,3.164-.08,1.09,0,2.18.027,3.3.08a29.8,29.8,0,0,1,3.376.372v36.473a62.361,62.361,0,0,1-1.09,12.042,23.5,23.5,0,0,1-3.881,9.331,18.3,18.3,0,0,1-7.5,6.008,29.116,29.116,0,0,1-11.91,2.127,29.029,29.029,0,0,1-11.91-2.127,18.089,18.089,0,0,1-7.5-6.008A23.5,23.5,0,0,1,81.2,205.6a62.365,62.365,0,0,1-1.09-12.042Z'
            transform='translate(-23.407 -155.992)'
            fill='#575756'
          />
          <path
            id='Tracciato_579'
            data-name='Tracciato 579'
            d='M147.591,210.089a35.749,35.749,0,0,1,1.941,5.184,37.77,37.77,0,0,1,1.117,5.37,44.2,44.2,0,0,1-8.427,2.26,55.014,55.014,0,0,1-8.082.532,34.022,34.022,0,0,1-13.451-2.472,26.568,26.568,0,0,1-9.7-6.939,29.512,29.512,0,0,1-5.9-10.607,43,43,0,0,1-1.994-13.372,41.76,41.76,0,0,1,2.074-13.4,30.91,30.91,0,0,1,6.008-10.687,27.4,27.4,0,0,1,9.65-7.045,32.205,32.205,0,0,1,13.053-2.526,56.507,56.507,0,0,1,7.975.532,34.234,34.234,0,0,1,7.9,2.26,20.157,20.157,0,0,1-1.09,5.29c-.611,1.7-1.276,3.456-1.994,5.184a43.3,43.3,0,0,0-5.583-1.542,30.59,30.59,0,0,0-5.769-.452q-8.653,0-13.319,5.636t-4.652,16.748q0,22.011,18.688,22.011a34.746,34.746,0,0,0,5.875-.452,38.569,38.569,0,0,0,5.689-1.542Z'
            transform='translate(14.703 -156.39)'
            fill='#575756'
          />
          <path
            id='Tracciato_580'
            data-name='Tracciato 580'
            d='M168.241,210.089a35.76,35.76,0,0,1,1.941,5.184,37.8,37.8,0,0,1,1.117,5.37,44.2,44.2,0,0,1-8.427,2.26,55.014,55.014,0,0,1-8.082.532,34.022,34.022,0,0,1-13.451-2.472,26.569,26.569,0,0,1-9.7-6.939,29.515,29.515,0,0,1-5.9-10.607,43,43,0,0,1-1.994-13.372,41.757,41.757,0,0,1,2.074-13.4,30.908,30.908,0,0,1,6.008-10.687,27.4,27.4,0,0,1,9.65-7.045,32.206,32.206,0,0,1,13.053-2.526,56.507,56.507,0,0,1,7.975.532,34.236,34.236,0,0,1,7.9,2.26,20.157,20.157,0,0,1-1.09,5.29c-.611,1.7-1.276,3.456-1.994,5.184a43.3,43.3,0,0,0-5.583-1.542,30.591,30.591,0,0,0-5.769-.452q-8.653,0-13.318,5.636t-4.652,16.748q0,22.011,18.689,22.011a34.749,34.749,0,0,0,5.875-.452,38.57,38.57,0,0,0,5.689-1.542Z'
            transform='translate(48.948 -156.39)'
            fill='#575756'
          />
          <path
            id='Tracciato_581'
            data-name='Tracciato 581'
            d='M146.01,157.132a39.838,39.838,0,0,1,6.593-.532,44.506,44.506,0,0,1,6.673.532v25.441h21.746V157.132a39.849,39.849,0,0,1,6.593-.532,44.521,44.521,0,0,1,6.673.532v64.891a40.994,40.994,0,0,1-6.593.532,43.152,43.152,0,0,1-6.673-.532V193.95H159.275v28.072a40.994,40.994,0,0,1-6.593.532,43.153,43.153,0,0,1-6.673-.532V157.132Z'
            transform='translate(85.881 -156.042)'
            fill='#575756'
          />
          <path
            id='Tracciato_582'
            data-name='Tracciato 582'
            d='M169.627,156.8h36.819a27.2,27.2,0,0,1,.532,5.5,30.168,30.168,0,0,1-.532,5.689h-23.66v14.089h18.768a29.4,29.4,0,0,1,.532,5.609,31.238,31.238,0,0,1-.532,5.689H182.786v17.147h24.271a27.2,27.2,0,0,1,.532,5.5,30.175,30.175,0,0,1-.532,5.689H169.6V156.827Z'
            transform='translate(125.002 -155.71)'
            fill='#575756'
          />
          <path
            id='Tracciato_583'
            data-name='Tracciato 583'
            d='M203.484,167.992H187.322a28.127,28.127,0,0,1-.532-5.689,29.264,29.264,0,0,1,.532-5.5h45.591a27.2,27.2,0,0,1,.532,5.5,30.171,30.171,0,0,1-.532,5.689H216.75v53.7c-1.09.133-2.153.213-3.243.319-1.09.08-2.127.133-3.164.133s-2.127-.027-3.3-.08a33.083,33.083,0,0,1-3.562-.372v-53.7Z'
            transform='translate(153.509 -155.71)'
            fill='#575756'
          />
          <path
            id='Tracciato_584'
            data-name='Tracciato 584'
            d='M223.415,167.992H207.252a28.124,28.124,0,0,1-.532-5.689,29.264,29.264,0,0,1,.532-5.5h45.591a27.2,27.2,0,0,1,.532,5.5,30.181,30.181,0,0,1-.532,5.689H236.68v53.7c-1.09.133-2.153.213-3.243.319-1.09.08-2.127.133-3.163.133s-2.127-.027-3.3-.08a33.076,33.076,0,0,1-3.562-.372v-53.7Z'
            transform='translate(186.561 -155.71)'
            fill='#575756'
          />
          <path
            id='Tracciato_585'
            data-name='Tracciato 585'
            d='M228.17,157.132a39.851,39.851,0,0,1,6.593-.532,44.508,44.508,0,0,1,6.673.532v64.891a40.993,40.993,0,0,1-6.593.532,43.149,43.149,0,0,1-6.672-.532Z'
            transform='translate(222.133 -156.042)'
            fill='#575756'
          />
        </g>
        <rect id='Rettangolo_223' data-name='Rettangolo 223' width='778.666' height='4.094' fill='#575756' />
      </g>
    </svg>
  )
}

export default Logosvg
